export const LOCAL_STORAGE_NEWSLETTER_KEY = '@doris:skip_newsletter'
